import type { Point, SceneNode } from "../scene/model";
import { textData } from "../native/text";
import { textCurveBox } from "../native/text-deformation";
import { nodeMatrix } from "../native/transforms";
import { transformPoint } from "../geometry/affine";
import { perspective } from "../native/deformation";
import { inverseBilinear } from "../native/bilinear";
import { edgePatch, hasEdgeWarp } from "../geometry/edge-warp";

/** Same composition as the raster: text path, projective quad, then edge patch. */
export function textProjector(node: SceneNode) {
  const box = textCurveBox(textData(node)),
    matrix = nodeMatrix(node),
    quad = node.geometry.warpCorners;
  const patch =
    quad && hasEdgeWarp(node.geometry.warpEdges)
      ? edgePatch(quad, node.geometry.warpEdges!)
      : null;
  const unbilinear = patch && quad ? inverseBilinear(quad) : null;
  return (p: Point) => {
    const u = (p.x - box.x) / box.width,
      v = (p.y - box.y) / box.height;
    let local = { x: u - 0.5, y: v - 0.5 };
    if (quad) {
      local = perspective(quad, u, v);
      if (patch && unbilinear) {
        const uv = unbilinear(local.x, local.y);
        local = patch.point(uv.x, uv.y);
      }
    }
    return transformPoint(local, matrix);
  };
}
